"use client";

import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";

/**
 * Ilot client d'une question de FAQ : seule l'ouverture/fermeture vit ici. La
 * reponse est rendue par le serveur et passee en `children`, ce qui evite
 * d'envoyer son JSON Lexical et le convertisseur RichText au navigateur.
 */
export function AccordionItem({
  question,
  children,
}: {
  question: string;
  children?: React.ReactNode;
}) {
  return (
    <Disclosure as="div" className=" pb-6">
      {({ open }) => (
        <>
          <dt>
            <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
              <span className="text-base font-semibold leading-7">
                {question}
              </span>
              <span className="ml-6 flex h-7 items-center">
                {open ? (
                  <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                ) : (
                  <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                )}
              </span>
            </Disclosure.Button>
          </dt>
          <Disclosure.Panel
            as="dd"
            unmount={false}
            className="mt-2 pr-12 data-closed:hidden"
          >
            {children}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
